import { http, normalizeApiError } from './http'
import type { ContactFormPayload } from '@/types/domain'
import type {
  CategoriesResponse,
  NewsQuery,
  NewsResponse,
  ProductQuery,
  ProductsResponse,
  SerialCheckResponse,
} from '@/types/api'

const request = async <T>(factory: () => Promise<{ data: T }>): Promise<T> => {
  try {
    const { data } = await factory()
    return data
  } catch (error) {
    throw normalizeApiError(error)
  }
}

export const api = {
  getCategories: (signal?: AbortSignal) =>
    request<CategoriesResponse>(() => http.get('/v1/shop/categories', { signal })),

  getProducts: (params: ProductQuery, signal?: AbortSignal) =>
    request<ProductsResponse>(() => http.get('/v1/shop/products', { params, signal })),

  getNews: (params?: NewsQuery, signal?: AbortSignal) =>
    request<NewsResponse>(() => http.get('/v1/shop/news', { params, signal })),

  checkSerialNumber: (serialNumber: string, signal?: AbortSignal) =>
    request<SerialCheckResponse>(() =>
      http.post('/v1/shop/check/serial_number', { serial_number: serialNumber }, { signal }),
    ),

  sendMessage: (payload: ContactFormPayload, signal?: AbortSignal) =>
    request<unknown>(() => http.post('/v1/util/send_bid', payload, { signal })),
}
